import MainTitle from '@/molecules/titles/MainTitle';
import SecondaryTitle from '@/molecules/titles/SecondaryTitle';
import { SIZE } from '@/types/utils';
import React, { PropsWithChildren } from 'react';
import { ExtraProps } from 'react-markdown';

type HeadingProps = PropsWithChildren<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>
>;

const H1Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <MainTitle {...props} size={SIZE.MD}>
    {children}
  </MainTitle>
);

const H2Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <SecondaryTitle {...props}>{children}</SecondaryTitle>
);

const H3Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <h3 className="title-3" {...props}>
    {children}
  </h3>
);

const H4Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <h4 className="title-4" {...props}>
    {children}
  </h4>
);

const H5Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <h5 className="title-5" {...props}>
    {children}
  </h5>
);

const H6Renderer = ({ children, node, ...props }: HeadingProps & ExtraProps) => (
  <h6 className="title-6" {...props}>
    {children}
  </h6>
);

export { H1Renderer, H2Renderer, H3Renderer, H4Renderer, H5Renderer, H6Renderer };
